import { useMemo } from 'react';
import { resolveGoogleAdsIds } from '../utils/googleAdsClickId';

import { getCookie, safeJsonParse, getGAClientId } from '../../utils/utils';

/**
 * Builds a stable analytics payload (Elevar + gclid + client id).
 * Intended to be computed BEFORE submission and passed into submit/webhook.
 */
export default function useAnalyticsData() {
  return useMemo(() => {
    const elevarParamsRaw = localStorage.getItem('___ELEVAR_GTM_SUITE--params');
    const elevarParamsObj = safeJsonParse(elevarParamsRaw, {});

    const { gclid, gbraid, wbraid, gad_source, gad_campaignid } = resolveGoogleAdsIds(
      elevarParamsObj,
      {
        gclid_value: localStorage.getItem('gclid_value'),
        gclid: localStorage.getItem('gclid'),
      }
    );

    const used_pip_calculator = getCookie('used_pip_calculator') === 'true' ? 'Yes' : 'No';

    // console.log('elevarParamsObj', ...elevarParamsObj);

    return {
      ...elevarParamsObj,

      // Preserve: raw JSON string and cookie blob as separate fields
      elevar_params: elevarParamsRaw,
      elevar_cookies: localStorage.getItem('___ELEVAR_GTM_SUITE--cookies'),

      client_id: getGAClientId(),

      gclid,
      gclid_value: gclid,
      google_ads_click_id: gclid,
      gbraid,
      wbraid,
      gad_source,
      gad_campaignid,

      used_pip_calculator,

      // Optional extra context (kept for parity with older payloads)
      // interest_categories: localStorage.getItem('wgCollectionNames'),
    };
  }, []);
}
